const state = {
    isMobile: window.innerWidth < 768,
};

export default {
    namespaced: true,
    state,
};
